"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BugSpawnSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
const Utils_1 = require("../../../Shared/Utils");
const types_1 = require("../../../Shared/types");
const Bug_1 = require("../../Assemblages/Bug");
class BugSpawnSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.BUG_SPAWN);
        this.bugTypeLookup = {};
        this.timeSinceLastSpawn = 0;
        this.bugProbabilityLookup = {};
        this.previous30SpawnedBugs = [];
        this.numberOfFullGrownFlowers = 0;
        this.refreshTotalCount = 0;
        this.bugs = [];
    }
    onClear() {
    }
    onLocalMessage(message) {
        switch (message.type) {
            case Constants_1.MESSAGES.GAME_STATE_INITIALIZED:
                const data = message.data;
                data.levels.find(l => l.name === 'island').state.items.forEach(i => {
                    if (i.name === 'bee') {
                        this.initializeBug(i.x, i.y, i.uid);
                    }
                });
                this.numberOfFullGrownFlowers = this.$api.getNumberOfFullGrownFlowers();
                setTimeout(() => {
                    this.numberOfFullGrownFlowers = this.$api.getNumberOfFullGrownFlowers();
                }, 100);
                break;
            case Constants_1.MESSAGES.FLOWER_FULLY_GROWN:
            case Constants_1.MESSAGES.NEW_FLOWER:
                this.numberOfFullGrownFlowers = this.$api.getNumberOfFullGrownFlowers();
                break;
        }
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    onEntityAddedComponent(entity, component) {
        this.bugs.push(entity);
        this.dispatchAllLocal({
            type: Constants_1.MESSAGES.SPAWNED_BUG,
            data: entity,
        });
        if (this.globals.tileWorld.currentMap === "island") {
            this.initGameObjectForBug(entity);
        }
    }
    onEntityRemovedComponent(entity, component) {
        if (entity.gameObject) {
            delete entity.gameObject.entity;
            entity.gameObject.removeFromMap();
            delete entity.gameObject;
        }
        this.bugs = this.bugs.filter(b => b !== entity);
        this.dispatchAllLocal({
            type: Constants_1.MESSAGES.REMOVED_BUG,
            data: entity,
        });
    }
    getNumberOfBees() {
        return this.bugs.length;
    }
    get spawnMultiplier() {
        if (this.numberOfFullGrownFlowers < 5) {
            return .5;
        }
        else if (this.numberOfFullGrownFlowers < 10) {
            return .7;
        }
        else if (this.numberOfFullGrownFlowers < 15) {
            return 2;
        }
        else if (this.numberOfFullGrownFlowers < 25) {
            return 3.5;
        }
        else if (this.numberOfFullGrownFlowers < 40) {
            return 4;
        }
        else if (this.numberOfFullGrownFlowers < 60) {
            return 5;
        }
        else if (this.numberOfFullGrownFlowers < 80) {
            return 6;
        }
        else if (this.numberOfFullGrownFlowers < 110) {
            return 7;
        }
        else {
            return 18;
        }
    }
    getNextBugToSpawn() {
        return types_1.BugTypes.BEE;
        const intervals = [];
        let sum = 0;
        Object.keys(this.bugProbabilityLookup).forEach(k => {
            intervals.push({ bugType: k, start: sum, end: sum += this.bugProbabilityLookup[k] });
        });
        let nextBug;
        const number = Utils_1.getRandomNumber(0, sum);
        for (let i = 0; i < intervals.length; i++) {
            if (intervals[i].start <= number && intervals[i].end <= number) {
                nextBug = intervals[i].type;
                break;
            }
        }
        if (nextBug) {
            let timesItWasSpawnedLast30 = 0;
            for (let i = 0; i < this.previous30SpawnedBugs.length; i++) {
                if (this.previous30SpawnedBugs[i] === nextBug) {
                    timesItWasSpawnedLast30++;
                }
            }
            if (timesItWasSpawnedLast30 > 5) {
                this.bugProbabilityLookup[nextBug] -= 1;
            }
            return nextBug;
        }
    }
    initGameObjectForBug(bug) {
        const sprite = new PIXI.Sprite(this.globals.gameTextures.animations.bugs.bee[0]);
        sprite.anchor.set(.5, .5);
        const go = this.globals.tileWorld.addGameObject({
            sprite,
            layer: 2,
            colliders: [{
                    layer: 2,
                    tags: [Constants_1.COLLIDER_TAGS.bug],
                    shapeData: { x: -7, y: -2, w: 14, h: 10 },
                    dynamic: true,
                }]
        });
        bug.gameObject = go;
        bug.gameObject.entity = bug;
    }
    onStart() {
        this.addApi(this.getNumberOfBees);
        this.globals.tileWorld.onBeforeMapDestroyed(mapName => {
            if (mapName === 'island') {
                this.bugs.forEach(b => {
                    if (b.gameObject) {
                        delete b.gameObject.entity;
                        b.gameObject.removeFromMap();
                        delete b.gameObject;
                    }
                });
            }
        });
        this.globals.tileWorld.onMapCreated(mapName => {
            if (mapName === 'island') {
                this.bugs.forEach(b => {
                    if (!b.gameObject) {
                        this.initGameObjectForBug(b.gameObject);
                    }
                });
            }
        });
    }
    addNewBug() {
        const possibleSpawns = [
            { x: [0, 10], y: [0, 2000] },
            { x: [2000, 2001], y: [0, 2000] },
            { x: [0, 2000], y: [0, 10] },
            { x: [0, 2000], y: [2000, 2010] },
        ];
        const random = Utils_1.getRandomItemFromArray(possibleSpawns);
        const spawnPositionX = Utils_1.getRandomNumber(random.x[0], random.x[1]);
        const spawnPositionY = Utils_1.getRandomNumber(random.y[0], random.y[1]);
        const uid = this.$api.getUid();
        this.initializeBug(spawnPositionX, spawnPositionY, uid);
    }
    initializeBug(x, y, uid) {
        const bug = new Bug_1.Bug(uid, types_1.BugTypes.BEE);
        const bugData = {
            type: types_1.BugTypes.BEE,
            speed: 5,
            position: { x, y },
            angle: 1,
            size: 1,
            frames: this.globals.gameTextures.animations.bugs.bee,
        };
        this.initializeEntity(bug, bugData);
    }
    update(delta) {
        if (!this.$api.gameStateInitialized())
            return;
        this.timeSinceLastSpawn += (delta * this.spawnMultiplier);
        if (this.timeSinceLastSpawn > 25) {
            this.addNewBug();
            this.timeSinceLastSpawn = 0;
        }
    }
}
exports.BugSpawnSystem = BugSpawnSystem;
//# sourceMappingURL=module.js.map